import { jsxs, jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
import "../shared/quiz-blank.js";
import { KatexText } from "../shared/katex-text.js";
import "react";
import "react-i18next";
import "../shared/quiz-style-context.js";
import "../../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../../context/DevToolsContext.js";
import "../../../utils/quiz-parser.js";
import { getImageUrl, getPrintScale, PrintQuizTitle, PrintQuizProblem, getStyles } from "./print-common.js";
function ImageSelectPrint({
  quizId,
  quiz,
  number,
  showCorrectAnswers = false,
  correctAnswers,
  compact
}) {
  const s = getStyles(compact);
  const imageUrl = getImageUrl(quiz.image, quiz.imagePrint);
  const printScale = getPrintScale(quiz.image, quiz.imagePrint);
  const correctKeySet = new Set(correctAnswers ?? []);
  return /* @__PURE__ */ jsxs("div", { className: cn(s.container, s.quizSection), children: [
    /* @__PURE__ */ jsx(PrintQuizTitle, { number, compact, children: /* @__PURE__ */ jsx(KatexText, { text: quiz.title }) }),
    /* @__PURE__ */ jsx(
      PrintQuizProblem,
      {
        problem: quiz.problem,
        quizId,
        additionalImages: quiz.additionalImages,
        compact
      }
    ),
    imageUrl && /* @__PURE__ */ jsx("div", { className: "flex justify-center w-full", children: /* @__PURE__ */ jsxs(
      "div",
      {
        className: "relative inline-block origin-center",
        style: {
          transform: `scale(${printScale ?? 0.75})`
        },
        children: [
          /* @__PURE__ */ jsx(
            "img",
            {
              src: imageUrl,
              alt: "quiz",
              className: "max-w-full h-auto"
            }
          ),
          quiz.choices.map((rect, idx) => {
            const isCorrect = showCorrectAnswers && correctKeySet.has(rect.key);
            const x = Math.max(0, rect.x);
            const y = Math.max(0, rect.y);
            const width = rect.x + rect.width > 100 ? 100 - rect.x : rect.width;
            const height = rect.y + rect.height > 100 ? 100 - rect.y : rect.height;
            return /* @__PURE__ */ jsx(
              "div",
              {
                className: "absolute",
                style: {
                  left: `${x}%`,
                  top: `${y}%`,
                  width: `${width}%`,
                  height: `${height}%`
                },
                children: /* @__PURE__ */ jsx(
                  "span",
                  {
                    className: cn(
                      "absolute -top-[8px] -left-[8px] w-[20px] h-[20px] rounded-full flex items-center justify-center text-[11px] font-bold",
                      isCorrect ? "bg-[#e50000] text-white" : "bg-white text-[#999] border border-[#ccc]"
                    ),
                    children: idx + 1
                  }
                )
              },
              rect.key
            );
          })
        ]
      }
    ) })
  ] });
}
export {
  ImageSelectPrint
};
//# sourceMappingURL=image-select-print.js.map
